module.exports = __webpack_public_path__ + "static/img/detail-wikiW.f622c580.png";